import { CATALOG_FILTER_EXISTS } from '@backstage/catalog-client';
import type { Entity } from '@backstage/catalog-model';
import { REGISTERS, useRegisterCounts } from './api';
import { EntityBrowser } from './EntityBrowser';

/** The catalog is filled from four registers, and this is where most people look for them. */
function RegisterShortcuts() {
  const counts = useRegisterCounts();
  return (
    <>
      <nldd-container layout="wrap" gap="8" vertical-alignment="center">
        {REGISTERS.map(register => {
          const count = counts[register.key];
          return (
            <nldd-button
              key={register.key}
              appearance="neutral-tinted"
              size="sm"
              href={register.catalogPath}
              text={count === undefined ? register.shortTitle : `${register.shortTitle} (${count.toLocaleString('nl-NL')})`}
            />
          );
        })}
        <nldd-link size="sm" href="/registers" end-icon="arrow-right" text="Over de registers" />
      </nldd-container>
      <nldd-spacer size="16" />
    </>
  );
}

export const CatalogBrowser = () => (
  <EntityBrowser
    title="Catalogus"
    description="Alles wat de overheid bouwt en publiceert, op één plek."
    intro={<RegisterShortcuts />}
    itemName="onderdelen"
  />
);

const adrScore = (entity: Entity) => {
  const score = entity.metadata.annotations?.['overheid.nl/adr-score'];
  return score === undefined ? undefined : `ADR ${score}`;
};

export const ApiBrowser = () => (
  <EntityBrowser
    title="API's"
    description="Elke API uit het API-register, met zijn score op de API Design Rules."
    kinds={['API']}
    itemName="API's"
    badge={adrScore}
  />
);

const HAS_DOCS = { 'metadata.annotations.backstage.io/techdocs-ref': CATALOG_FILTER_EXISTS };

export const DocsBrowser = () => (
  <EntityBrowser
    title="Documentatie"
    description="Alles wat een team zelf bij zijn code schrijft, op één plek."
    itemName="documentatie"
    filter={HAS_DOCS}
    href={entity =>
      `/docs/${entity.metadata.namespace ?? 'default'}/${entity.kind.toLowerCase()}/${entity.metadata.name}`
    }
  />
);

// Aan de slag groups its templates by what you want to do, see TemplateGroups.tsx.
export { TemplateGroups as TemplateBrowser } from './TemplateGroups';
